import React, {useCallback, useEffect, useState} from 'react';
import Grid from "@material-ui/core/Grid";
import {AuthorService} from "../../services/author.service";
import {ManuscriptModel} from "../../models/manuscript.model";
import {toggleLoader} from "../../store/global/global-slice";
import {useDispatch} from "react-redux";
import {NewBookShort} from "../../components/author/books/new-book-short";
import {PaginationModel} from "../../models/pagination.model";
import {StyledButton} from "../../components/ui-base/button";
import {useTranslation} from "react-i18next";


const AuthorBooksListPage = () => {
    const [manuscripts, setManuscripts] = useState<PaginationModel<ManuscriptModel[]>>(null);
    const dispatch = useDispatch();
    const { t } = useTranslation('common');

    const loadManuscripts = useCallback(async (page: number = 0, perPage: number = 12) => {
        const res = await AuthorService.getMyManuscripts(page, perPage);

        if (page === 0) {
            setManuscripts(res);
        } else {
            setManuscripts((old) => {
               return {
                   ...res,
                   results: [...old.results, ...res.results]
               }
            });
        }

        dispatch(toggleLoader(false));
    }, [dispatch]);

    const loadNextManuscripts = () => {
        dispatch(toggleLoader(true));
        loadManuscripts(manuscripts.results.length / 12, 12);
    }

    useEffect(() => {
        dispatch(toggleLoader(true));

        loadManuscripts();
    }, [dispatch, loadManuscripts]);


    return (
        <Grid item container direction={"column"}>
            <Grid item container direction={"row"} spacing={2}>
                {manuscripts?.results.map((manuscript, index) => (
                    <NewBookShort key={manuscript.id} manuscript={manuscript}/>
                ))}
            </Grid>

            {manuscripts?.next &&
            <Grid container direction={"row"} justifyContent={"center"} style={{marginTop: '30px'}}>
                <StyledButton type={"button"} color={"transparent"} onClick={() => {
                    loadNextManuscripts();
                }}>
                    {t('loadNext')}
                </StyledButton>
            </Grid>
            }
        </Grid>
    )
}

export default AuthorBooksListPage;
